module.exports = __webpack_public_path__ + "img/cimb.659730f2.svg";